<div class="pageOptionPanelContainer">
    <input id="pageOptionPanel" class="editDatadictionaryCheckbox" type="checkbox" (change)="hisBaseGlobalsService.dataDictionaryEditMode.set($event.target.checked)">
    <label for="pageOptionPanel" class="editDatadictionaryLabel">Edit Datadictionary</label>
    @if (searchConfigFileValue) {
        <strong>&nbsp;{{'cs.sys.debug.searchconfig' | hisUi}}</strong><a data-role="search-config-link" href="#" (click)="sendSearchConfigFileToJsf(); $event.preventDefault()">{{ searchConfigFileValue }}</a>
    }
</div>
